<script setup lang="ts">
import { computed } from 'vue'
import { useAuthStore } from '@/stores/auth'

const auth = useAuthStore()
const isAdmin = computed(() => auth.isAdmin)
const adminName = computed(() => auth.user?.tenant_name || 'your administrator')
const supportEmail = 'hello@vetware.io'
</script>

<template>
  <div class="max-w-md mx-auto py-12 px-6 text-center">
    <template v-if="isAdmin">
      <h1 class="text-2xl font-bold text-gray-900 mb-3">Set up your first engraver</h1>
      <p class="text-gray-700 mb-6">
        Your Keepsake account is ready, but you don't have an engraver connected
        yet. Plug yours in and connect it with your phone; it takes a couple of
        minutes.
      </p>
      <RouterLink
        to="/setup"
        class="inline-block bg-gray-900 text-white px-6 py-3 rounded-lg hover:bg-gray-800 transition text-lg"
      >
        Set up engraver
      </RouterLink>
      <p class="text-sm text-gray-500 mt-6">
        Flashing your own AtomStack?
        <RouterLink to="/setup/usb" class="underline">Use USB setup</RouterLink>.
      </p>
    </template>

    <template v-else>
      <h1 class="text-2xl font-bold text-gray-900 mb-3">Waiting for your engraver</h1>
      <p class="text-gray-700 mb-3">
        Your team's Keepsake account doesn't have an engraver connected yet, so
        there's nothing for you to do here just yet.
      </p>
      <p class="text-gray-700">
        Ping {{ adminName }} — once they finish setup you'll be able to make
        your first paw print.
      </p>
      <p class="text-sm text-gray-500 mt-6">
        Questions? Email
        <a :href="`mailto:${supportEmail}`" class="underline">{{ supportEmail }}</a>.
      </p>
    </template>
  </div>
</template>
